export const healthchessLogConstants = {
  GETHEALTHCHESS_LOG_REQUEST: 'GETHEALTHCHESS_LOG_REQUEST',
  GETHEALTHCHESS_LOG_SUCCESS: 'GETHEALTHCHESS_LOG_SUCCESS',
  GETHEALTHCHESS_LOG_FAILURE: 'GETHEALTHCHESS_LOG_FAILURE',
};
